<template>
  <div
    class="form-group busca-simples-api"
    v-click-outside="onClickOutside"
    @keydown.esc="ShowBox = false"
  >
    <span class="form-control form-control-sm" @click="ShowBox = true">
      {{ SearchText }}
    </span>
    <div class="busca-simples-api-lista" v-if="ShowBox">
      <div v-if="ItemsProp.length == 0 || Items.length == 0" class="text-center py-1">
        <span>{{ $t ? $t('noRecordsToShow') : 'Nenhum registro para ser exibido' }}</span>
      </div>
      <div v-if="Items.length > 0">
        <table class="table table-active border table-striped text-center text-sm table-sm m-0">
          <thead>
            <tr class="font-weight-bold">
              <td></td>
              <td>{{ $t('mondayShort') }}</td>
              <td>{{ $t('tuesdayShort') }}</td>
              <td>{{ $t('wednesdayShort') }}</td>
              <td>{{ $t('thursdayShort') }}</td>
              <td>{{ $t('fridayShort') }}</td>
              <td>{{ $t('saturdayShort') }}</td>
              <td>{{ $t('sundayShort') }}</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in Items" :key="index">
              <td class="font-weight-bold">
                {{ item['name'] }}
              </td>
              <td>
                <template v-if="item['days'].hasOwnProperty('seg')">
                  <select
                    class="form-control form-control-sm text-center"
                    :class="{ 'dia-passado': isPastDay(item['days']['seg']['date']) }"
                    :disabled="passDay(item['days']['seg']['date'])"
                    v-model="item['days']['seg']['copiar']"
                    @change="item['days']['seg']['block'] = false"
                  >
                    <option value="0"></option>
                    <option v-for="(item, index) in this.grupos" :key="index" :value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </template>
              </td>
              <td>
                <template v-if="item['days'].hasOwnProperty('ter')">
                  <select
                    class="form-control form-control-sm text-center"
                    :class="{ 'dia-passado': isPastDay(item['days']['ter']['date']) }"
                    :disabled="passDay(item['days']['ter']['date'])"
                    v-model="item['days']['ter']['copiar']"
                    @change="item['days']['ter']['block'] = false"
                  >
                    <option value="0"></option>
                    <option v-for="(item, index) in this.grupos" :key="index" :value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </template>
              </td>
              <td>
                <template v-if="item['days'].hasOwnProperty('qua')">
                  <select
                    class="form-control form-control-sm text-center"
                    :class="{ 'dia-passado': isPastDay(item['days']['qua']['date']) }"
                    :disabled="passDay(item['days']['qua']['date'])"
                    v-model="item['days']['qua']['copiar']"
                    @change="item['days']['qua']['block'] = false"
                  >
                    <option value="0"></option>
                    <option v-for="(item, index) in this.grupos" :key="index" :value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </template>
              </td>
              <td>
                <template v-if="item['days'].hasOwnProperty('qui')">
                  <select
                    class="form-control form-control-sm text-center"
                    :class="{ 'dia-passado': isPastDay(item['days']['qui']['date']) }"
                    :disabled="passDay(item['days']['qui']['date'])"
                    v-model="item['days']['qui']['copiar']"
                    @change="item['days']['qui']['block'] = false"
                  >
                    <option value="0"></option>
                    <option v-for="(item, index) in this.grupos" :key="index" :value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </template>
              </td>
              <td>
                <template v-if="item['days'].hasOwnProperty('sex')">
                  <select
                    class="form-control form-control-sm text-center"
                    :class="{ 'dia-passado': isPastDay(item['days']['sex']['date']) }"
                    :disabled="passDay(item['days']['sex']['date'])"
                    v-model="item['days']['sex']['copiar']"
                    @change="item['days']['sex']['block'] = false"
                  >
                    <option value="0"></option>
                    <option v-for="(item, index) in this.grupos" :key="index" :value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </template>
              </td>
              <td>
                <template v-if="item['days'].hasOwnProperty('sab')">
                  <select
                    class="form-control form-control-sm text-center"
                    :class="{ 'dia-passado': isPastDay(item['days']['sab']['date']) }"
                    :disabled="passDay(item['days']['sab']['date'])"
                    v-model="item['days']['sab']['copiar']"
                    @change="item['days']['sab']['block'] = false"
                  >
                    <option value="0"></option>
                    <option v-for="(item, index) in this.grupos" :key="index" :value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </template>
              </td>
              <td>
                <template v-if="item['days'].hasOwnProperty('dom')">
                  <select
                    class="form-control form-control-sm text-center"
                    :class="{ 'dia-passado': isPastDay(item['days']['dom']['date']) }"
                    :disabled="passDay(item['days']['dom']['date'])"
                    v-model="item['days']['dom']['copiar']"
                    @change="item['days']['dom']['block'] = false"
                  >
                    <option value="0"></option>
                    <option v-for="(item, index) in this.grupos" :key="index" :value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </template>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="8">
                <button
                  type="button"
                  id="btnSalvarGrupoDia"
                  @click="salvarDias"
                  class="btn bg-gradient-success btn-sm float-end mt-2 mb-0"
                >
                  {{ $t('save') }}
                </button>
              </td>
            </tr>
          </tfoot>
        </table>
        <!--          <div class="item span-striped pointer" v-for="(item, key) in Items" :key="key" @click="clickItem(item, key)">
            <slot name="item" :item="item">
              <div class="form-check">
                <input class="mt-1 form-check-input" type="checkbox" v-model="item.copiar" />
                <span class="ms-1"> {{item[Field]}}</span>
              </div>
            </slot>
          </div>-->
      </div>
      <!-- <div v-if="CreateItem && SearchText.length >= 3" class="py-3 text-center" id="divCadastro" style="cursor: pointer;">
          <span @click="registerItem()">Clique aqui para cadastrar o item <span class="font-weight-bold">{{SearchText}}</span></span>
        </div> -->
    </div>
  </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3'
import moment from 'moment/moment'
export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  name: 'select2',
  props: [
    'ApiUrlProp',
    'ApiDataProp',
    'PlaceholderTextProp',
    'WidthProp',
    'FieldProp',
    'ItemsProp',
    'ClearAfterSelectedProp',
    'SelectedItemProp',
    'CreateItemProp',
    'GruposProp',
  ],
  data() {
    return {
      itemsSelecionados: [],
      ApiUrl: '',
      ApiData: '',
      PlaceholderText: '',
      Field: '',
      Items: [],
      ShowBox: false,
      SearchText: 'Clique aqui para definir semanas e dias',
      ClearAfterSelected: false,
      CreateItem: false,
      grupos: [],
      today: moment(new Date()).format('yyyy-MM-DD'),
    }
  },
  created() {
    this.grupos = this.GruposProp
    this.ApiUrl = this.ApiUrlProp
    this.ApiData = this.ApiDataProp
    this.PlaceholderText = this.PlaceholderTextProp
    this.Width = this.WidthProp ? this.WidthProp : '100%'
    this.CreateItem = this.CreateItemProp ? this.CreateItemProp : false
    this.Field = this.FieldProp
    this.Items = this.ItemsProp

    this.ClearAfterSelected = this.ClearAfterSelectedProp ? this.ClearAfterSelectedProp : false
    //this.changeText()
    if (this.SelectedItemProp) {
      this.clickItem(this.SelectedItemProp)
    }
  },
  watch: {
    /*SelectedItemProp: function () {
        this.clickItem(this.SelectedItemProp)
      }*/
    // ItemsProp: function () {
    //   this.changeText()
    // }
  },
  methods: {
    passDay(/* date */) {
      // Bloqueio de edicao em dias passados desativado a pedido do treinador.
      // Permite configurar/reconfigurar o treino em qualquer dia do plano,
      // inclusive planos que ja comecaram ou terminaram.
      return false
    },
    isPastDay(date) {
      // Retorna true se a data ja passou (usado apenas para destacar visualmente,
      // nao para bloquear edicao).
      if (!date) return false
      const day = moment(date).format('yyyy-MM-DD')
      return day < this.today
    },
    salvarDias() {
      this.$emit('salvarDias')
    },
    onClickOutside() {
      this.ShowBox = false
    },
    changeText() {
      this.$emit('searchText', this.SearchText)
      if (this.SearchText.length >= 3) {
        // this.ShowBox = false
        //this.Items = this.ItemsProp.length > 10 ? this.ItemsProp.slice(0, 10) : this.ItemsProp
        this.ItemsSearch()
        // this.OutItem.emit(null)
      }
      if (this.SearchText.length == 0) {
        this.clickItem(null)
      }
    },
    ItemsSearch() {
      //let items = this.ItemsProp.filter( x => x[this.FieldProp].toLowerCase().includes(this.SearchText.toLowerCase()))
      let filterKey = this.SearchText.toLowerCase()
      //console.log(filterKey)
      filterKey = filterKey.replace(/[^a-zA-Z0-9]/g, '')
      let data = this.ItemsProp
      let items = []

      if (this.Field != '') {
        items = data.filter((row) => {
          return Object.keys(row).some((/*key*/) => {
            return (
              String(row[this.Field])
                .replace(/[^a-zA-Z0-9]/g, '')
                .toLowerCase()
                .indexOf(filterKey) > -1
            )
          })
        })
      } else {
        items = data.filter((row) => {
          return Object.keys(row).some((key) => {
            return (
              String(row[key])
                .replace(/[^a-zA-Z0-9]/g, '')
                .toLowerCase()
                .indexOf(filterKey) > -1
            )
          })
        })
      }
      this.Items = items
    },
    onSearch(searchText) {
      if (searchText === null || searchText.match(/^ *$/) !== null) {
        this.OutItem.emit(null)
        return
      }
      let data = { parametro: searchText, empresa: this.varsProd.NomeEmpresa }
      this.searchBoxService.PostListItems(this.urlApiService, data).subscribe((response) => {
        this.Items = response['dados']
      })
    },
    clickItem(item) {
      console.log(item)
    },
    blurEvent() {
      this.ShowBox = false
    },
    registerItem() {
      this.$emit('CreatingItem', this.SearchText)
    },
  },
}
</script>

<style scoped>
/* Select dos grupos com largura mínima para mostrar texto completo */
.table select.form-control-sm {
  min-width: 45px;
  font-size: 0.75rem;
}

/* Dia ja passou — destaque visual cinza claro, mas continua editavel */
.table select.form-control-sm.dia-passado {
  background-color: #e9ecef !important;
  color: #6c757d !important;
  border-color: #ced4da !important;
}
.table select.form-control-sm.dia-passado:focus {
  background-color: #e9ecef !important;
  color: #6c757d !important;
  box-shadow: 0 0 0 0.15rem rgba(206, 212, 218, 0.5) !important;
}
.table select.form-control-sm.dia-passado option {
  background-color: #ffffff;
  color: #212529;
}

#divCadastro:hover {
  background-color: #efefef;
}
.span-striped:nth-child(even) {
  background-color: #f2f2f2;
}
.busca-simples-api {
  position: relative;
}
.busca-simples-api .busca {
  width: 100%;
  margin-bottom: 0;
}
.busca-simples-api .busca-simples-api-lista {
  width: max-content;
  min-width: 100%;
  max-height: 300px;
  position: absolute;
  left: 0;
  z-index: 2;
  background-color: white;
  box-shadow: 0px 1px 3px 1px #989797;
  overflow-x: visible;
  overflow-y: auto;
  margin-top: 2px;
}
.busca-simples-api .busca-simples-api-lista .item {
  padding: 7px 16px;
  font-weight: bold;
  font-size: 15px;
  cursor: pointer;
}
.busca-simples-api .busca-simples-api-lista .item:hover {
  background-color: #4fc3f7;
  color: white;
}
.busca-simples-api .busca-simples-api-lista::-webkit-scrollbar {
  width: 10px;
}
.busca-simples-api .busca-simples-api-lista::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #ded9d9;
  border-radius: 20px;
  margin: 2px;
  width: 10px;
}
.busca-simples-api .busca-simples-api-lista::-webkit-scrollbar-thumb {
  background-color: #ded9d9;
  border-radius: 20px;
}
.busca-simples-api .busca-simples-api-lista::-webkit-scrollbar-thumb:hover {
  background-color: #bfbfbf;
}
</style>
